import React from "react";
import PrdCommentary from "../../features/icprdcommentary";

const PrdCommentaryPage = () => <PrdCommentary />

export default PrdCommentaryPage;